import type { DisputeAnswer } from '@shared/factory-dispute';
import { SUGGESTION_ACTION_LABELS } from '@shared/factory-suggestions';

/** "Left as the builder says", "Sent back to fix: per order", "Left as the builder says (No thanks on its suggestion)", "Sent back for the builder's other option: …". */
export function disputeAnswerText(answer: DisputeAnswer, unclear = false): string {
  const what = unclear
    ? answer.choice === 'leave'
      ? 'Accepted as it is'
      : 'Asked the builder to report its verdict'
    : answer.choice === 'leave'
      ? 'Left as the builder says'
      : answer.choice === 'other'
        ? `Sent back for the builder’s other option${answer.option ? `, “${answer.option}”` : ''}`
        : 'Sent back to the builder to fix';
  const via = answer.via === 'suggestion' && answer.action ? ` (${SUGGESTION_ACTION_LABELS[answer.action]} on its suggestion)` : '';
  const note = answer.note && answer.via === 'card' ? `: ${answer.note}` : '';
  return `${what}${via}${note}`;
}
